// extracted by mini-css-extract-plugin
module.exports = {"container":"AddBadge_container__j4kcL","content":"AddBadge_content__1R2IS"};